module.exports = __webpack_public_path__ + "static/img/pic_02@2x.ba7cdced.png";